// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-shape-divider-top-1700484497{left:0;line-height:0;overflow:hidden;top:0;width:100%}.custom-shape-divider-top-1700484497 svg{display:block;height:70px;width:calc(161% + 2.3px)}@media (max-width:767px){.custom-shape-divider-top-1700484497 svg{height:41px;width:calc(160% + 1.3px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
